module.exports = __webpack_public_path__ + "static/media/7.62f25bcf.png";